import * as types from "./mutations-type";
export default{
    [types.SET_MSG](state,payload){
        state.msg = payload
    },
    [types.SET_EDITAR](state,payload){
        state.editar = payload
    },
    [types.SET_LISTA](state,payload){
        state.lista = payload
    },
    [types.SET_PESQUISA](state,payload){
        state.pesquisa = payload
    },
    [types.SET_SERVICO](state,payload){
        state.servico = payload
    },
    [types.SET_COMISSIONADOR](state,payload){
        state.comissionado = payload
    },
    [types.SET_DIAS](state,payload){
        state.dias = payload
    },
    [types.SET_BASECALCULO](state,payload){
        state.basecalculo = payload
    },
    [types.SET_FOLHAR_ID](state,payload){
        state.folhar_id = payload
    },
    [types.SET_VALORCALCULO](state,payload){
        state.valorcalculo = payload
    },
    [types.SET_GERAL](state,payload){
        state.geral = payload
    },
    [types.SET_QUINZENA](state,payload){
        state.quinzena = payload
    },
    [types.SET_VALORCALCULO_GERAL](state,payload){
        state.valorcalculogeral = payload
    },
    [types.SET_EVENTO](state,payload){
        state.evento = payload
    },
    [types.SET_BANCOS](state,payload){
        state.bancos = payload
    },
    [types.SET_RUBLICAS](state,payload){
        state.rublicas = payload
    },
    [types.SET_TOMADORES](state,payload){
        state.tomadores = payload
    },
}